import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const tabs = ({ palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTabs"] => ({
	root: {
		color: palette.white,
	},
});

export default tabs;
